import { Route, Routes } from 'react-router-dom';
import LodgeReturn from './LodgeReturn';
import LodgeReturnApplication from './LodgeReturnApplication';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';

export const LodgeReturnRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<LodgeReturn />} />
      <Route path="application/:id?" element={<LodgeReturnApplication />} />
    </Routes>
  );
};
